
import { Vue, Component, Watch, Prop } from 'vue-property-decorator';
import _ from 'lodash';

@Component({
  components: {},
})
export default class PhotoEmployee extends Vue {
  @Prop({ type: String, default: '' }) readonly propSrc;
  @Prop({ required: true }) readonly propOnChangeFile!: (file: any) => void;
  @Prop({ type: String, default: '120' }) readonly propSize;

  srcAvatar: string = '';
  file: any = null;

  onChangeFile(file) {
    if (this.propOnChangeFile) {
      this.propOnChangeFile(file);
    }
  }
}
